import { useFilesContext } from '@/contexts/filesContext.tsx'
import { useState } from 'react'
import { Input } from 'react-daisyui'
import { Button } from '@/components/Button.tsx'
import LoadBig from '@/components/LoadBig/LoadBig.tsx'
import { useClient } from '@/stores/useClient.ts'
import { Trans, useTranslation } from 'react-i18next'
import { useDrives } from '@/stores/useDrives.ts'
import { IconGift, IconStarFilled } from '@tabler/icons-react'
import { useNavigate, useParams } from 'react-router-dom'

export default function YesIDoPage() {
  const { driveId } = useParams<{ driveId: string }>()
  const { currentDrive } = useDrives()
  const { currentAlbum: album } = useFilesContext()!
  const [email, setEmail] = useState('')
  const [isSending, setIsSending] = useState(false)
  const [wasSent, setWasSent] = useState(false)
  const { sendCoupon } = useClient()
  const navigate = useNavigate()
  const { drives } = useDrives()
  const drive = drives[driveId!]
  const { t } = useTranslation()

  function onHeaderClick() {
    navigate(`/d/${drive.id}/${album!.id}`)
  }

  async function onSendSubmit(e: any) {
    e.preventDefault()
    e.stopPropagation()
    if (isSending) {
      return
    }

    setIsSending(true)
    try {
      await sendCoupon(currentDrive!.id, email)
      setWasSent(true)
    } catch (e) {
      console.error('error sending coupon', e)
      alert(t('error.sendingError'))
    } finally {
      setIsSending(false)
    }
  }

  if (!album || !currentDrive) {
    return <LoadBig />
  }

  return <div>
    <div className='flex flex-col'>
      <div className={"flex flex-col gap-3 py-3 relative bg-primary"}>
        <div className='text-center'>
          <a
            className='bg-primary text-neutral font-serif text-center text-4xl my-3 block cursor-pointer'
            onClick={onHeaderClick}
          >
            FridaySnap
          </a>
        </div>
      </div>
    </div>

    {/*<DriveHeader title={currentDrive.drive_type === HeyDriveType.WEDDING ? (t('common.yesIDo') + '...') : null} description=' ' hideImage noMb />*/}
      <div className='container mx-auto flex flex-col gap-3 items-center max-w-[30rem] text-center'>
        <div className='w-full max-h-[20rem] max-w-[40rem] overflow-hidden relative'>
          <img className='w-full' src="/yes-i-do-hero.webp" alt="" />
          <div className='absolute bottom-0 left-0 w-full  bg-primary bg-opacity-80 text-neutral text-sm flex items-center justify-center gap-2 py-1'>
            {t('common.thousandsOfWeddingsAccompanied')}
            <span>|</span>
            <a href="https://de.trustpilot.com/review/fridaysnap.de" className='flex flex-row justify-center items-center'>
              4,8/5 <IconStarFilled size={12} className='me-1' /> {t('common.onTrustpilot')}
            </a>
          </div>
        </div>
      </div>
      <div className='container px-4 mx-auto flex flex-col gap-3 items-center max-w-[25rem] text-center'>
        <p className='text-xl mt-5'>
          {t('common.youAreGuestBride')}
        </p>
        <p>
          {t('common.memoriesWithUs')}
        </p>
      </div>
      <div className='bg-primary bg-opacity-20 mx-auto flex flex-col gap-3 items-center text-center mt-5'>
        <form className='p-5 rounded-xl flex flex-col gap-3 min-w-[20rem] py-[2rem]' onSubmit={onSendSubmit}>
          <span className='text-xl font-bold flex flex-row justify-center items-center'>
            <IconGift className='me-3 text-primary' size={30} />
            {t('common.couponPc', { percent: '10' })}
          </span>
          { !wasSent && <>
            <p className='text-xl bg-neutral rounded-lg font-medium p-1'>
              <Trans i18nKey='common.couponSecure' components={{ 1: <br /> }} values={{ percent: '10' }} />
            </p>
            <div className='flex flex-col gap-3'>
              <Input className='bg-neutral' type='email' required color='primary' placeholder={t('common.yourEmail')} value={email} onChange={e => setEmail(e.target.value)} />
              <Button className='text-neutral' color='primary' disabled={isSending} loading={isSending}>
                {t('common.couponReceive')}
              </Button>
            </div>
            <div className='mt-5'>
            </div>
          </> }
          {
            wasSent && <p className='text-neutral'>
              {t('common.couponSent')}
            </p>
          }
        </form>
      </div>
    </div>
  }
